import { render, staticRenderFns } from "./capa.vue?vue&type=template&id=0c8aa78e"
import script from "./capa.vue?vue&type=script&lang=js"
export * from "./capa.vue?vue&type=script&lang=js"
import style0 from "./capa.vue?vue&type=style&index=0&id=0c8aa78e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports